<div *ngIf="!isLoading; else spinner" >
  <h1 mat-dialog-title xmlns="http://www.w3.org/1999/html">
    <ng-container *ngIf="!isNew; else addTitle">Edit Pilot Activated Lighting</ng-container>
  </h1>
  <mat-dialog-content [formGroup]="formGroup">
    <div class="form-container">
      <p>
        <mat-form-field>
          <mat-select placeholder="Intensity *" [(value)]="selectedIntensity" name="intensity" formControlName="intensity">
            <mat-option value="low">Low</mat-option>
            <mat-option value="medium">Medium</mat-option>
            <mat-option value="high">High</mat-option>
          </mat-select>
        </mat-form-field>
      </p>
      <p>
      <mat-form-field>
        <input matInput
               placeholder="# of Clicks *"
               formControlName="clicks"
               type="number"
               min="1"
               step="1"
               [(ngModel)]="selectedClicks"
               (focusout)="numOfClicksUnfocus()"/>
      </mat-form-field>
      </p>
      <p>
        <mat-form-field>
          <input matInput
                 placeholder="# of Seconds *"
                 formControlName="seconds"
                 type="number"
                 min="1"
                 step="1"
                 [(ngModel)]="selectedSeconds"
                 (focusout)="numOfSecondsUnfocus()"/>
        </mat-form-field>
      </p>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="submit" [disabled]="!formGroup.valid" class="mat-raised-button submit-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
<ng-template id="spinnerContainer" #spinner>
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</ng-template>
<ng-template #addTitle>
  Add Pilot Activated Lighting
</ng-template>
